import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=2da209d2&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da209d2')) {
      api.createRecord('2da209d2', component.options)
    } else {
      api.reload('2da209d2', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=2da209d2&", function () {
      api.rerender('2da209d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Spinner.vue"
export default component.exports